var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.398 1L11.1939 2.15637M11.1939 2.15637L13 3.89092L10.8928 5.91457L9.08668 4.18002M11.1939 2.15637L9.08668 4.18002M6.61225 6.55636C6.92312 6.85092 7.17024 7.20163 7.33938 7.5883C7.50853 7.97496 7.59636 8.38993 7.59783 8.80933C7.59929 9.22873 7.51435 9.64426 7.34791 10.032C7.18146 10.4197 6.9368 10.772 6.628 11.0686C6.3192 11.3652 5.95236 11.6001 5.54862 11.76C5.14487 11.9198 4.71219 12.0014 4.27548 12C3.83877 11.9986 3.40667 11.9142 3.00405 11.7518C2.60142 11.5893 2.23624 11.352 1.92951 11.0535C1.32634 10.4537 0.992581 9.65044 1.00013 8.81665C1.00767 7.98286 1.35591 7.18527 1.96985 6.59567C2.58379 6.00607 3.41429 5.67163 4.2825 5.66439C5.1507 5.65714 5.98714 5.97767 6.61165 6.55693L6.61225 6.55636ZM6.61225 6.55636L9.08668 4.18002",
    stroke: "#1F2445",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPasswordIcon);
export default __webpack_public_path__ + "static/media/newPasswordIcon.166516da6a9a2eba75bbe62af4f3025b.svg";
export { ForwardRef as ReactComponent };